import { Component, Input } from '@angular/core';
import { TrafficLights } from '@app/pcs/models';
import { GridCell } from 'ngrx-data-grid';

@Component({
  templateUrl: './traffic-lights-extended-column.component.html'
})
export class TrafficLightsExtendedColumnComponent implements GridCell<TrafficLights[]> {
  @Input() data: TrafficLights[];

}
